import { Table } from '@tanstack/react-table';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

import { NotificationRulesTableFacedFilter } from './notification-rules-table-faceted-filter.tsx';
import {
  NotificationRule,
  notificationRuleStatuses,
} from '@/features/notification-rules/schemas/notification-rules.schema.ts';
import { CreateNotificationRule } from '@/features/notification-rules/components/create-notification-rule/create-notification-rule.tsx';
import { Cross2Icon } from '@radix-ui/react-icons';
import { NotificationRulesTableToolbarDeleteDialog } from '@/features/notification-rules/components/notification-rules-table/notification-rules-table-toolbar-delete-dialog.tsx';
import { NotificationRulesTableToolbarEditDropdown } from '@/features/notification-rules/components/notification-rules-table/notification-rules-table-toolbar-edit-dropdown-menu.tsx';

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function NotificationRulesTableToolbar<TData extends NotificationRule>({
  table,
}: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0;

  return (
    <div className="flex justify-between gap-4">
      <div className="flex flex-1 flex-col flex-wrap gap-2 sm:flex-row">
        <Input
          placeholder="Filter notification rules by title..."
          value={(table.getColumn('notificationTitle')?.getFilterValue() as string) ?? ''}
          onChange={(event) =>
            table.getColumn('notificationTitle')?.setFilterValue(event.target.value)
          }
          className="h-8 w-full max-w-[250px] bg-white"
        />
        {table.getColumn('status') && (
          <NotificationRulesTableFacedFilter
            column={table.getColumn('status')}
            title="Status"
            options={notificationRuleStatuses}
          />
        )}
        {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => table.resetColumnFilters()}
            className="h-8 w-min px-2 lg:px-3"
          >
            Reset
            <Cross2Icon className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>
      <div className="flex flex-col gap-2 sm:flex-row">
        <div className="order-2 flex flex-wrap gap-2 sm:order-0">
          {table.getFilteredSelectedRowModel().rows.length > 0 ? (
            <NotificationRulesTableToolbarEditDropdown
              notificationRules={table
                .getFilteredSelectedRowModel()
                .rows.map((row) => row.original)}
              onSuccess={() => table.toggleAllRowsSelected(false)}
            />
          ) : null}
          {table.getFilteredSelectedRowModel().rows.length > 0 ? (
            <NotificationRulesTableToolbarDeleteDialog
              notificationRules={table
                .getFilteredSelectedRowModel()
                .rows.map((row) => row.original)}
              onSuccess={() => table.toggleAllRowsSelected(false)}
            />
          ) : null}
        </div>
        {/*<NotificationRulesTableViewOptions table={table} />*/}
        <CreateNotificationRule />
      </div>
    </div>
  );
}
